module.exports = __webpack_public_path__ + "static/img/male-2.982e7062.webp";